/* Upakarna polish pass (5 Oct 2026): shared behaviour for the rebuilt components.
   Countdown (festive), banner slider, stack tabs, add-one and add-many to the drawer, creators video, sticky CTA,
   announcement rotation. No dependencies; the cart drawer re-renders through its own renderContents. */
(function () {
  'use strict';
  var routes = window.routes || {};
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Countdown: days and hours left to the festive order-by deadline; hides itself after it passes. */
  function tickCountdown() {
    $$('[data-upk-countdown]').forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-deadline') || '');
      if (!t) return;
      var left = t - Date.now();
      var out = el.querySelector('[data-upk-countdown-text]') || el;
      if (left <= 0) { el.hidden = true; return; }
      var d = Math.floor(left / 86400000), h = Math.floor((left % 86400000) / 3600000), m = Math.floor((left % 3600000) / 60000);
      var text = d > 1 ? d + ' days left' : d === 1 ? '1 day ' + h + ' hrs left' : h > 0 ? h + ' hrs ' + m + ' min left' : m + ' min left';
      if (out.textContent !== text) out.textContent = text;
    });
  }
  tickCountdown(); setInterval(tickCountdown, 60000);

  /* The announcement rotor lives in sections/upk-announcement.liquid (P5.2). */

  /* Banner slider: dots, autoplay, pause on touch. */
  $$('[data-upk-banner]').forEach(function (b) {
    var track = b.querySelector('[data-upk-banner-track]'); if (!track) return;
    var slides = $$('.upk-banner__slide', track); if (slides.length < 2) return;
    var dots = $$('.upk-banner__dot', b); var i = 0; var timer = null;
    function go(n) { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
    function start() { if (b.getAttribute('data-autoplay') !== 'true') return; stop(); timer = setInterval(function () { go(i + 1); }, (parseInt(b.getAttribute('data-interval'), 10) || 5) * 1000); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    track.addEventListener('scroll', function () { var k = Math.round(track.scrollLeft / track.clientWidth); if (k !== i) { i = k; dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); }); } }, { passive: true });
    track.addEventListener('touchstart', stop, { passive: true }); track.addEventListener('touchend', start, { passive: true });
    b.addEventListener('mouseenter', stop); b.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });

  /* Stack tabs; a stack collection page opens its own tab first */
  function selectStackTab(tab) {
    var root = tab.closest('[data-upk-stk]'); if (!root) return;
    $$('[data-upk-stk-tab]', root).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    $$('[data-upk-stk-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-upk-stk-panel') !== tab.getAttribute('data-upk-stk-tab'); });
    loadStackPanel(root, tab);
  }
  /* P13c.3: a rail that carries data-upk-stk-src has no cards in the page; on its first tap the section is fetched rendered on
     the tab's stack collection URL (Section Rendering API) and the cards of the rail with the same handle are copied in. */
  function loadStackPanel(root, tab) {
    var panel = root.querySelector('[data-upk-stk-panel="' + tab.getAttribute('data-upk-stk-tab') + '"]'); if (!panel) return;
    var ul = panel.querySelector('[data-upk-stk-src]'); if (!ul || ul.dataset.upkLoaded) return;
    ul.dataset.upkLoaded = '1';
    var sid = root.id.replace(/^upk-stk-/, ''); var handle = ul.getAttribute('data-upk-stk-handle');
    fetch(ul.getAttribute('data-upk-stk-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (json) {
        var html = json[sid]; if (!html) throw new Error('no section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var from = doc.querySelector('[data-upk-stk-handle="' + handle + '"]'); if (!from) throw new Error('no rail');
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(from.children).forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
        ul.innerHTML = ''; ul.appendChild(frag); ul.removeAttribute('aria-busy'); ul.removeAttribute('data-upk-stk-src');
        if (window.upkLazy) window.upkLazy.watch(ul);
      })
      .catch(function () { delete ul.dataset.upkLoaded; });
  }
  document.addEventListener('click', function (e) { var tab = e.target.closest('[data-upk-stk-tab]'); if (tab) selectStackTab(tab); });
  $$('[data-upk-stk][data-upk-stk-active]').forEach(function (root) {
    var t = root.querySelector('[data-upk-stk-tab="' + root.getAttribute('data-upk-stk-active') + '"]'); if (t) selectStackTab(t);
  });

  /* Add to cart (one variant, or many) and re-render the drawer */
  function addItems(items, btn, doneLabel) {
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding...';
    return fetch((routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add');
        var dr = document.querySelector('cart-drawer');
        if (dr && res.data.sections && typeof dr.renderContents === 'function') dr.renderContents(res.data);
        try { document.dispatchEvent(new CustomEvent('upk:cart:added', { detail: res.data })); } catch (err) {}
        btn.textContent = doneLabel || 'Added'; btn.classList.add('is-done');
        setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-done'); }, 1800);
      })
      .catch(function (err) { btn.disabled = false; btn.textContent = label; if (window.upkToast) window.upkToast(err.message || 'Could not add, try again'); });
  }
  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-upk-add-one]');
    if (one && !one.disabled) { var id = parseInt(one.getAttribute('data-upk-add-one'), 10); if (id) addItems([{ id: id, quantity: 1 }], one); return; }
    var many = e.target.closest('[data-upk-add-many]');
    if (many && !many.disabled) {
      var ids = (many.getAttribute('data-upk-add-many') || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
      if (ids.length) addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), many, 'Added the look');
    }
  });

  /* Gift box colour (OPEN-ITEMS 70): swap the gift line's variant, keep its properties, re-render */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-upk-gift-colour]'); if (!sel) return;
    var key = sel.getAttribute('data-line-key'); var vid = parseInt(sel.value, 10); if (!key || !vid) return;
    var props = {}; try { props = JSON.parse(sel.getAttribute('data-props') || '{}'); } catch (err) {}
    if (Array.isArray(props)) { var obj = {}; props.forEach(function (p) { if (p && p.length === 2) obj[p[0]] = p[1]; }); props = obj; }
    if (!props._gift) props._gift = 'true';
    sel.disabled = true;
    fetch((routes.cart_change_url || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { return fetch((routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) }); })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var dr = document.querySelector('cart-drawer');
        if (document.querySelector('cart-items') && !sel.closest('cart-drawer')) { window.location.reload(); return; }
        if (dr && d.sections && typeof dr.renderContents === 'function') dr.renderContents(d);
        sel.disabled = false;
      })
      .catch(function () { sel.disabled = false; window.location.reload(); });
  });

  /* Creators: load the video on tap only */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-upk-crt-media]'); if (!m) return;
    var card = m.closest('.upk-crt__card'); var src = m.getAttribute('data-video'); if (!src) return;
    var v = m.querySelector('video');
    if (!v) { v = document.createElement('video'); v.setAttribute('playsinline', ''); v.controls = true; v.preload = 'metadata'; v.src = src; m.appendChild(v); }
    $$('.upk-crt__card.is-playing video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.upk-crt__card').classList.remove('is-playing'); } });
    card.classList.add('is-playing'); v.play().catch(function () {});
  });

  /* Sticky CTA on landing pages: show after the hero */
  var scta = $('[data-upk-scta]');
  if (scta) {
    document.body.classList.add('upk-has-scta');
    var hero = $('.upk-banner, .upk-lphero'); var threshold = hero ? hero.offsetHeight : 400;
    function onScroll() { scta.classList.toggle('is-on', window.scrollY > threshold); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
})();
